export default {
  startLoading: 'Beladung starten',
  finishLoading: 'Beladung beenden',
  loadEditDisabled: 'Nur geplante Chargen können bearbeitet werden.',
};
